import { Container, Row, Col, NavItem, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Button, Box, Card, IconButton, Tooltip, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import './inventoryDashboard.css';
import React, { useState, useEffect } from "react";

import { getLocalStorageItem } from '../../../common/localStorageUtils';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { authKey, GET_DASHBOARD_INVENTORY_SUM } from '../../../common/URLs';
import { ViewIcon } from '../../../common/icons';
import apiClient from '../../../axios';
import { useLocation } from 'react-router-dom';

const rows = [
  {
    sideHead: "Unrestricted",
    id: 1,
    locationGrower: "-",
    inTransitLLE: "-",
    inTransitPlant: "-",
    inTransitIs: "-",
    locationLle: "-",
    locationPlant: "-",
    locationIs: "-",

  },
  {
    sideHead: "Restricted",
    id: 2,
    locationGrower: "-",
    inTransitLLE: "-",
    inTransitPlant: "-",
    inTransitIs: "-",
    locationLle: "-",
    locationPlant: "-",
    locationIs: "-",
  },
  {
    sideHead: "Scrap",
    id: 3,
    locationGrower: "-",
    inTransitLLE: "-",
    inTransitPlant: "-",
    inTransitIs: "-",
    locationLle: "-",
    locationPlant: "-",
    locationIs: "-",
  },
  {
    sideHead: "Total Inventory ",
    id: 4,
    locationGrower: 0,
    inTransitLLE: 0,
    inTransitPlant: 0,
    inTransitIs: "-",
    locationLle: "-",
    locationPlant: "-",
    locationIs: "-",
  }
];

const cbRows = [
  {
    sideHead: "Unrestricted",
    id: 1,
    locationGrower: "-",
    inTransitLLE: "-",
    inTransitPlant: "-",
    inTransitIs: "-",
    locationLle: "-",
    locationPlant: "-",
    locationIs: "-",

  },
  {
    sideHead: "Restricted",
    id: 2,
    locationGrower: "-",
    inTransitLLE: "-",
    inTransitPlant: "-",
    inTransitIs: "-",
    locationLle: "-",
    locationPlant: "-",
    locationIs: "-",
  },
  {
    sideHead: "Scrap",
    id: 3,
    locationGrower: "-",
    inTransitLLE: "-",
    inTransitPlant: "-",
    inTransitIs: "-",
    locationLle: "-",
    locationPlant: "-",
    locationIs: "-",
  },
  {
    sideHead: "Total Inventory ",
    id: 4,
    locationGrower: "-",
    inTransitLLE: "-",
    inTransitPlant: 0,
    inTransitIs: "-",
    locationLle: "-",
    locationPlant: "-",
    locationIs: "-",
  }
];

function InventoryDashboard() {

  const location = useLocation();
const [tabValue, setTabValue] = React.useState(
 location.state?.materialType ?? "RawBamboo"
);
  const [inventorySum, setInventorySum] = React.useState();
  const [rowRawBaboo, setRowRawBamboo] = React.useState([]);
  const [rowChipBaboo, setRowChipBamboo] = React.useState([]);
  const navigate = useNavigate();


  const columns = [
    {
      field: 'sideHead',
      width: 150,
      cellClassName: 'sideHead',
      renderHeader: () => (
        <strong>
          {''}
          <span role="img" aria-label="enjoy">

          </span>
        </strong>
      ),
    },
    // {
    //   field: 'locationGrower',
    //   width: 150,
    //   renderCell: (cellValues) => {
    //     return (
    //       <>{cellValues.row.locationGrower}  {cellValues.row.locationGrower != "-" && 
    //         <Tooltip title="View">
    //       <IconButton color="primary" onClick={() => { navigate("/inventoryDashboard/growerPopUp") }} ><ViewIcon /></IconButton>
    //       </Tooltip>}</>
    //     )
    //   },
    //   renderHeader: () => (
    //     <strong>
    //       {'Location - Grower'}
    //       <span role="img" aria-label="enjoy">

    //       </span>
    //     </strong>
    //   ),
    // },

    {
      field: 'inTransitLLE',
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>{cellValues.row.inTransitLLE}  {cellValues.row.inTransitLLE != "-" && 
            <Tooltip title="View">
          <IconButton
 onClick={() => {
   navigate("/dashboardHome/inventory/stakeholderPopUp", {
     state: {
       materialType: tabValue, 
       from: "inventoryDashboard"
     }
   });
 }}
><ViewIcon /></IconButton>
          </Tooltip>}</>
        )
      },
      renderHeader: () => (
        <strong>
          {'In Transit - LLE'}
          <span role="img" aria-label="enjoy">

          </span>
        </strong>
      ),
    },
    {
      field: 'inTransitPlant',
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>{cellValues.row.inTransitPlant}  {cellValues.row.inTransitPlant != "-" && 
            <Tooltip title="View">
          <IconButton color="primary" onClick={() => { navigate("/inventoryDashboard/Intransit") }} ><ViewIcon /></IconButton>
          </Tooltip>}</>
        )
      },
      renderHeader: () => (
        <strong>
          {'In Transit - Plant'}
          <span role="img" aria-label="enjoy">

          </span>
        </strong>
      ),
    },
    {
      field: 'inTransitIs',
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>{cellValues.row.inTransitIs}  {cellValues.row.inTransitIs != "-" && 
            <Tooltip title="View">
          <IconButton color="primary" onClick={() => { navigate("/inventoryDashboard/Intransit") }}><ViewIcon /></IconButton>
          </Tooltip>}</>
        )
      },
      renderHeader: () => (
        <strong>
          {'In Transit - IS'}
          <span role="img" aria-label="enjoy">

          </span>
        </strong>
      ),
    },
    {
      field: 'locationLle',
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>{cellValues.row.locationLle}  {cellValues.row.locationLle != "-" && 
            <Tooltip title="View">
          <IconButton color="primary" onClick={() => { navigate("/inventoryDashboard/stakeholderPopUp",
          { state: { "stakeHolderType": "LLE", "materialType": tabValue, "inventoryCategory": cellValues.row.sideHead } }) }} ><ViewIcon /></IconButton>
          </Tooltip>}</>
        )
      },
      renderHeader: () => (
        <strong>
          {'Location - LLE'}
          <span role="img" aria-label="enjoy">

          </span>
        </strong>
      ),
    },
    {
      field: 'locationPlant',
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>{cellValues.row.locationPlant}  {cellValues.row.locationPlant != "-" && 
            <Tooltip title="View">
          <IconButton color="primary" onClick={() => { navigate("/inventoryDashboard/stakeholderPopUp", { state: { "stakeHolderType": "Plant", "materialType": tabValue, "inventoryCategory": cellValues.row.sideHead } }) }} ><ViewIcon /></IconButton>
          </Tooltip>}</>
        )
      },
      renderHeader: () => (
        <strong>
          {'Location - Plant'}
          <span role="img" aria-label="enjoy">

          </span>
        </strong>
      ),
    },
    {
      field: 'locationIs',
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>{cellValues.row.locationIs}  {cellValues.row.locationIs != "-" &&
            <Tooltip title="View">
             <IconButton color="primary" onClick={() => { navigate("/inventoryDashboard/stakeholderPopUp", { state: { "stakeHolderType": "IS", "materialType": tabValue, "inventoryCategory": cellValues.row.sideHead } }) }} ><ViewIcon /></IconButton>
             </Tooltip>
             }</>
        )
      },
      renderHeader: () => (
        <strong>
          {'Location - IS'}
          <span role="img" aria-label="enjoy">

          </span>
        </strong>
      ),
    },
  ];
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

  };
  const getIneventoryDashBoard = () => {
    apiClient
      .post(GET_DASHBOARD_INVENTORY_SUM,
        {

        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        console.log(response?.data);
        //setRows(response?.data?.consignments);
        setInventorySum(response?.data?.inventoryDashboardSum);
        let rawBambooRow = rows
        let chipBambooRow = cbRows
        response?.data?.inventoryDashboardSum.forEach(element => {
          if (element?.materialType === "RawBamboo") {
            element?.inventorySumList?.forEach(item => {
              if (item?.category === "Unrestricted") {
                rawBambooRow?.forEach(ele => {
                  if (ele.sideHead === "Unrestricted" && element?.stakeHolderType === "LLE") {
                    ele.locationLle = item.sum
                  }
                  if (ele.sideHead === "Unrestricted" && element?.stakeHolderType === "Plant") {
                    ele.locationPlant = item.sum
                  }
                  if (ele.sideHead === "Unrestricted" && element?.stakeHolderType === "InterimStorage") {
                    ele.locationIs = item.sum
                  }
                })
              }
              if (item?.category === "Restricted") {
                rawBambooRow?.forEach(ele => {
                  if (ele.sideHead === "Restricted" && element?.stakeHolderType === "LLE") {
                    ele.locationLle = item.sum
                  }
                  if (ele.sideHead === "Restricted" && element?.stakeHolderType === "Plant") {
                    ele.locationPlant = item.sum
                  }
                  if (ele.sideHead === "Restricted" && element?.stakeHolderType === "InterimStorage") {
                    ele.locationIs = item.sum
                  }
                })
              }
              if (item?.category === "Scrap") {
                rawBambooRow?.forEach(ele => {
                  if (ele.sideHead === "Scrap" && element?.stakeHolderType === "LLE") {
                    ele.locationLle = item.sum
                  }
                  if (ele.sideHead === "Scrap" && element?.stakeHolderType === "Plant") {
                    ele.locationPlant = item.sum
                  }
                  if (ele.sideHead === "Scrap" && element?.stakeHolderType === "InterimStorage") {
                    ele.locationIs = item.sum
                  }
                })
              }
            })
          }
          if (element?.materialType === "ChipBamboo") {
            element?.inventorySumList?.forEach(item => {
              if (item?.category === "Unrestricted") {
                chipBambooRow?.forEach(ele => {
                  if (ele.sideHead === "Unrestricted" && element?.stakeHolderType === "LLE") {
                    ele.locationLle = item.sum
                  }
                  if (ele.sideHead === "Unrestricted" && element?.stakeHolderType === "Plant") {
                    ele.locationPlant = item.sum
                  }
                  if (ele.sideHead === "Unrestricted" && element?.stakeHolderType === "InterimStorage") {
                    ele.locationIs = item.sum
                  }
                })
              }
              if (item?.category === "Restricted") {
                chipBambooRow?.forEach(ele => {
                  if (ele.sideHead === "Restricted" && element?.stakeHolderType === "LLE") {
                    ele.locationLle = item.sum
                  }
                  if (ele.sideHead === "Restricted" && element?.stakeHolderType === "Plant") {
                    ele.locationPlant = item.sum
                  }
                  if (ele.sideHead === "Restricted" && element?.stakeHolderType === "InterimStorage") {
                    ele.locationIs = item.sum
                  }
                })
              }
              if (item?.category === "Scrap") {
                chipBambooRow?.forEach(ele => {
                  if (ele.sideHead === "Scrap" && element?.stakeHolderType === "LLE") {
                    ele.locationLle = item.sum
                  }
                  if (ele.sideHead === "Scrap" && element?.stakeHolderType === "Plant") {
                    ele.locationPlant = item.sum
                  }
                  if (ele.sideHead === "Scrap" && element?.stakeHolderType === "InterimStorage") {
                    ele.locationIs = item.sum
                  }
                })
              }
            })
          }
        });
        setRowRawBamboo(rawBambooRow);
        setRowChipBamboo(chipBambooRow)

      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (getLocalStorageItem('id_token')) {
      getIneventoryDashBoard();
    }
  }, []);

  return (


    <Container fluid>


      <Card>
        <TabContext value={tabValue} style={{ marginLeft: "1.5vh" }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'whitesmoke' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example" variant="scrollable">
              <Tab label="Raw Bamboo" value="RawBamboo" />
              <Tab label="Chipped Bamboo" value="ChipBamboo" />
            </TabList>
          </Box>
          <TabPanel value="RawBamboo" >
            <Box style={{ height: 400, width: '100%' }}>
              {

                <div style={{ height: 350, width: '100%' }}>
                  <DataGrid rows={rowRawBaboo} columns={columns} />
                </div>
              }
            </Box>
          </TabPanel>
          <TabPanel value="ChipBamboo" >
            <Box style={{ height: 400, width: '100%' }}>
              {
                <div style={{ height: 350, width: '100%' }}>
                  <DataGrid rows={rowChipBaboo} columns={columns} />
                </div>
              }
            </Box>
          </TabPanel>

        </TabContext>
      </Card>


    </Container>




  )

}
export default InventoryDashboard;